<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.gspl">
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">High speed spinner block</span>
          </u>
        </b>
        <b>
          <u>
            <span style="font-size:16.0pt;font-family:Arial;"></span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">This unit is used for spinning copper pipe, with high production efficiency, good quality, and high yield. The production of our company has been sold to Ukraine etc.</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span>&nbsp;</span>
      </p>
      <div align="center">
        <table
          style="width:90.0%;"
          class="ke-zeroborder"
          border="0"
          cellpadding="0"
          cellspacing="0"
          width="90%"
        >
          <tbody>
            <tr>
              <td style="background:#F4F4F4;">
                <p style="text-align:center;" align="center">
                  <span style="font-size:11.5pt;line-height:150%;font-family:宋体;color:#000099;">Technical parameters</span>
                  <span style="font-size:11.5pt;line-height:150%;font-family:Arial;color:#000099;"></span>
                  <span style="font-size:11.5pt;line-height:150%;font-family:宋体;color:#000099;"></span>
                  <span style="font-size:11.5pt;line-height:150%;font-family:Arial;color:#000099;"></span>
                  <span style="font-size:11.5pt;line-height:150%;font-family:宋体;color:#000099;"></span>
                  <span style="font-size:11.5pt;line-height:150%;font-family:Arial;color:#000099;"></span>
                  <span style="font-size:11.5pt;line-height:150%;font-family:宋体;color:#000099;"></span>
                  <span style="font-size:11.5pt;line-height:150%;font-family:Arial;color:#000099;"></span>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <div align="center">
                  <table
                    style="width:375.0pt;background:black;"
                    class="ke-zeroborder"
                    border="0"
                    cellpadding="0"
                    cellspacing="1"
                    width="500"
                  >
                    <tbody>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >No.</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Model</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Data</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Units</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ2130</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >－</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ2200</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ1800</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ1200</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ800</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Vertical block for capillary</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >1</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >diameter of drum</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >mm</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ2130</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ1800</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ1200</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ800</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ500</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >2</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >working length of the drum</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >mm</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >400</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >350</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >350</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >350</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >70</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >3</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >max. dimension of shell</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >mm</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ52×2.5</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ38×1.8</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ25×1.5</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ12×1</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ8×1.2</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >4</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >min dimension of the product</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >mm</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ4×0.35</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ4×0.35</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ3×0. 5</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ3×0. 5</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >Φ1.5×0. 5</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >5</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >max. coil weight</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >kg</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >550-1000</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >400</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >200</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >300</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >100</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >6</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >max. drawing force</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >kg</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >10000</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >6000</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >4000</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >2000</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >850</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >7</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >drawing speed</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >m/min</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0-150-800</span>
                          </p>
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0-1200</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0-400</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0-400</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0-400</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0-70</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >8</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >number of baskets for circulation</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >Piece</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >8</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >------</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >3</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >------</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >------</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >9</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >total installed power</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >kw</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >380-440</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >200</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >110</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >55</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >A.C11</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >10</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >consumption of compressed air</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >
                              m
                              <sup>3</sup>/min
                            </span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0.8</span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0.6</span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0.6</span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >0.6</span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >------</span>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td style="background:white;" width="22">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >11</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >electric control system</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="45">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            >&nbsp;</span>
                          </p>
                        </td>
                        <td style="background:white;" width="76">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >digital   system</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >dialogue between person and machine</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="65">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >digital system</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="67">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >digital system</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="62">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >digital system</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                        <td style="background:white;" width="78">
                          <p style="text-align:center;" align="center">
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:宋体;color:#333333;"
                            >AC frequency converting</span>
                            <span
                              style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#333333;"
                            ></span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p style="text-align:center;" align="center">
                  <span style="font-size:9.0pt;line-height:150%;font-family:ˎ̥;color:#000099;"></span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <span>&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <br>
        </span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        gspl: require("../../../assets/img/common/gspl.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/gspl.vue